import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_2fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
                31
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-lg font-bold text-foreground-950">31黑料网</span>
                <span className="text-[11px] font-medium tracking-[0.2em] text-secondary-600">
                  黑料排行 · 专题合集
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-[13px] leading-relaxed text-foreground-600">
              31黑料网以专题合集的方式整理每天的热议话题，把零散条目按事件归档、按热度排序，
              让 31黑料网黑料排行 与 31黑料网黑料榜单 更好读、也更容易回溯。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-background-50 px-3 py-1.5 text-[11px] font-medium text-foreground-600">
                11 个内容方向
              </span>
              <span className="rounded-full bg-background-50 px-3 py-1.5 text-[11px] font-medium text-foreground-600">
                90 天记录保留
              </span>
              <span className="rounded-full bg-background-50 px-3 py-1.5 text-[11px] font-medium text-foreground-600">
                每小时重算热度
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-sm font-bold text-foreground-950">{col.title}</h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="cursor-pointer text-[13px] text-foreground-600 transition-colors hover:text-primary-700"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div
          id="footer-note"
          className="mt-10 flex flex-col gap-3 border-t border-secondary-300/70 pt-6 sm:flex-row sm:items-center sm:justify-between"
        >
          <p className="text-xs leading-relaxed text-foreground-500">
            本站为演示性质的内容聚合页面，条目均为虚构示例，不指向任何真实人物或事件。
          </p>
          <p className="text-xs text-foreground-500">
            © 2026 31黑料网 · 内容整理与展示
          </p>
        </div>
      </div>
    </footer>
  );
}